import { makeObservable, observable, runInAction, action, makeAutoObservable, computed  } from 'mobx';
import { UserService } from '../services/userServices';
import { toast } from "react-toastify";
import i18n from 'i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { makePersistable, stopPersisting } from 'mobx-persist-store';

const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
);

const items = [
    { "id": 1, "username": "adam", "password": null, "name": "Adam Mathias", "surname": "Robin", "email": "adam@test.com", "type": 1, "code": 434 },    
];


export default class UsersAdminStore {

  

    rootStore;
    dummies = [];
    users = [];
    user = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;
      makeObservable(this, {
          /*config: observable,
          setConfig: action,*/

          dummies:observable,
          users: observable,
          user: observable,
          getAllUsers: action,
          getDummy: action,
          reset: action,
          getById: action,
          remove: action,
          searchConsultant: action,
          searchUserClient: action,
          duplicate: action,
          message: action,
          ignoreMessage: action,
          setInformation: action,
          getNotifications: action,
          markNotificationAsRead: action,
          recoverPassword: action,
          changePassword: action,
          sendEmail:action
      });

      makePersistable(this, { name: 'usersAdminStore', properties: ['config'], storage: window.localStorage });

    }

    duplicate = async (id) => {
        try {
            const data = await UserService.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("user") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    navigateTo=(props)=> {
        let navigate = useNavigate();
        navigate(props);
    }

    reset = () => {
        runInAction(() => this.user = {});
    }


    getDummy = async () => {
        await delay(1000);
        try {            
            runInAction(() => {
                this.dummies = items;
            })
        }
        catch (error) {            
            runInAction(() => {
                this.dummies = [];
            });
        }
        /*await delay(1000);
        runInAction(() => {           
            this.users = items;

            //console.log(this.users)
        });*/
    }

    searchConsultant = async (query) => {
        try {
            var result = UserService.search(3,query);
            return result;
        }
        catch (error) {
            return [];
        }

    }

    getNotifications = async (query) => {
        try {
            return UserService.notifications();            
        }
        catch (error) {
            return [];
        }

    }

    markNotificationAsRead = async (id) => {
        try {
            var result = UserService.markNotificationAsRead(id);
            runInAction(() => {
                //toast.success(i18n.t("notificationDismissed"));
            });
        }
        catch (error) {
            return [];
        }

    }

    searchUserClient = async (query) => {
        try {
            var result = UserService.search(2, query);
            return result;
        }
        catch (error) {
            return [];
        }

    }

    setConfig = (prop, c) => {
        runInAction(() => {            
            this.config[prop] = c;
        });
    }

    message = async (message) => {
        try {
            const data = await UserService.message(message);
            runInAction(() => {
                toast.success(i18n.t("messageSent"));
            });
        } catch (error) {
            runInAction(() => {
                //toast.error(i18n.t("errorOcurred"));
            });
        }
    }

    setInformation = async (message) => {
        try {
            const data = await UserService.information(message);
            runInAction(() => {
                toast.success(i18n.t("informationSaved"));
            });
        } catch (error) {
            runInAction(() => {
                //toast.error(i18n.t("errorOcurred"));
            });
        }
    }

    ignoreMessage = async (id) => {
        try {
            const data = await UserService.ignoreMessage(id);
            runInAction(() => {
                toast.success(i18n.t("messageIgnored"));
            });
        } catch (error) {
            runInAction(() => {
                //toast.error(i18n.t("errorOcurred"));
            });
        }
    }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {            
            const data = await UserService.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.users = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.users = [];
            });
        }
    }

    getAllUsers = async (page, filter, sort) => {
        try {
            const data = await UserService.getAll({ page: page,filter:filter,sort:sort });

            runInAction(() => {
                this.users = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.users = [];
            });
        }
        /*await delay(1000);
        runInAction(() => {           
            this.users = items;

            //console.log(this.users)
        });*/
    }

    /*get = async (id) => {
        runInAction(() => {
            this.user = items.filter(x => x.id == id)[0] || null;
        });
    }*/


    getById = async (id, onError) => {
        
        try {
            const data = await UserService.getById(id);
            runInAction(() => {
                this.user = data;
            });
        } catch (error) {
            if (onError && typeof onError === "function")
                onError();

            runInAction(() => {
                this.user = {};
            })
        }
    };

    getProfile = async () => {
        try {
            const data = await UserService.getProfile();
            runInAction(() => {
                this.user = data;
            });
        } catch (error) {
            runInAction(() => {
                this.user = {};
            })
        }
    };

    remove = async (id) => {
        try {
            const data = await UserService.delete(id);
            runInAction(() => {                                
                toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("user") })}`);
            });
        } catch (error) {
            runInAction(() => {
                //toast.error(i18n.t("errorOcurred"));
            });
        }
    }

    updateProfile = async (user,onSuccess) => {
        try {
            const data = await UserService.updateProfile(user);
            runInAction(() => {
                onSuccess?.();
                //this.reset();
                toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("profile") })}`);
            });
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }
    save = async (user,onSuccess) => {        
        if (user.id) {
            try {
                const data = await UserService.update(user.id, user);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();                    
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("user")})}`);
                });
            } catch (error) {                
                /*runInAction(() => {
                    toast.error(i18n.t(error || "errorOcurred"));
                });*/
            }
        } else {            
            try {
                const data = await UserService.create(user);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("user") })}`);
                    this.reset();                    
                    //this.navigate(0);
                });
            } catch (error) {                
                /*runInAction(() => {
                    toast.error(i18n.t(error || "errorOcurred"));
                });*/
            }
        }
    };

    recoverPassword = async (payload,onSuccess) => {
        try {
            const data = await UserService.recoverPassword(payload);
            runInAction(() => {
                onSuccess?.();
                toast.success(i18n.t("passwordReset"));
            });
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }

    sendEmail = async (payload, onSuccess) => {
        try {
            const data = await UserService.sendEmail(payload);
            runInAction(() => {
                onSuccess?.();
                toast.success(i18n.t("emailSent"));
            });
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }

    changePassword = async (payload,onSuccess) => {
        try {
            const data = await UserService.changePassword(payload);
            runInAction(() => {
                onSuccess?.();
                toast.success(i18n.t("passwordChanged"));
            });
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }

    updateLanguage = async (language) => {
        try {
            await UserService.updateLanguage(language);
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }
}